<script setup>
import PartnerList from '@/Pages/Dashboard/Support/Partners/Partials/PartnerList.vue';
import InputTag from '@/components/Shared/Form/InputTag.vue';
import { onMounted, ref } from 'vue';
import { router } from '@inertiajs/vue3';
import { debounce } from 'lodash';

const props = defineProps({
  suggestedPartners: {
    type: Array,
    required: true,
  },
  allPartners: {
    type: Array,
    required: true,
  },
  filters: {
    type: Array,
    default: () => [],
  },
});

const tags = ref([]);
const filters = ref([]);
const autoCompleteItems = ref([]);

const handleTagsChanged = tags => {
  filters.value = Object.assign({}, tags);

  router.get(
    route('dashboard.support.partners.index'),
    { filters: filters.value },
    {
      preserveState: true,
      preserveScroll: true,
      only: ['allPartners'],
    },
  );
};

const handleTagChanged = debounce(tag => {
  axios.get(route('api.support.partners-autocomplete', { tag: tag })).then(({ data }) => {
    autoCompleteItems.value = data;
  });
}, 500);

onMounted(() => {
  tags.value = props.filters;

  handleTagsChanged(tags.value);
});
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <div class="support-wrapper">
    <div class="support-content">
      <div class="mt-5 mb-2">
        <h2>{{ trans('__JSON__.Suggested Partners') }}:</h2>
        <p class="my-2">
          {{
            trans(
              '__JSON__.To ensure that we can support you in the best possible way, APIcenter has made a selection based upon your applications. You can select which partner who will support you.',
            )
          }}
        </p>
        <partner-list :partners="suggestedPartners" />
      </div>
      <div class="mt-5 mb-2">
        <div class="search-bar-wrapper">
          <h5 class="w-1/3">
            {{ trans('__JSON__.Search for another partner') }}
          </h5>
          <input-tag
            class="w-full"
            v-model="tags"
            :placeholder="trans('__JSON__.Search on application or partner')"
            @change="handleTagsChanged"
            @tag-changed="handleTagChanged"
            :autocomplete-items="autoCompleteItems"
            add-only-from-autocomplete
          />
        </div>
        <div class="my-2">
          <partner-list :partners="allPartners" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.support {
  &-content {
    width: 90%;
    margin: 0 auto;
  }
  &-wrapper {
    background: white;
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.search-bar {
  &-wrapper {
    display: flex;
    justify-content: flex-start;
    gap: 20px;

    & > h5 {
      margin-top: 8px;
    }
  }
}
</style>
